<template>
  <div class="tag-select">
    <select @change="add($event.target.value)">
      <option></option>
      <option :selected="tag.id === value" v-for="tag in availableTags" :key="tag.id" :value="tag.id" >{{`${tag.name} (${tag.template})`}}</option>
    </select>
    <label>Selected tags</label>
    <ul>
      <li v-for="tag in selectedTags" :key="tag.id" @click="remove(tag)" title="Remove tag"><span>{{`${tag.name} (${tag.template})`}}</span><i class="material-icons">clear</i></li>
    </ul>
  </div>
</template>

<script>

export default {
  name: "tagSelect",
  props: ["value", "tags"],
  data: () => {
    return {
      selectedTags: [],
      availableTags: [],
    }
  },
  methods: {
    setValue() {
      let value = ''
      this.selectedTags.map((tag) => {
        value += `${tag.id};`
      })
      this.$emit("input", value);
    },
    add(value) {
      this.availableTags.map((tag) => {
        if (tag.id === value) {
          this.selectedTags.push(tag)
        }
      })

      this.availableTags = this.availableTags.filter((tag) => {
        return tag.id !== value
      })

      this.setValue()
    },
    remove(tag) {
      this.selectedTags = this.selectedTags.filter((selectedTag) => {
        return !selectedTag.id.includes(tag.id)
      })

      this.availableTags.push(tag)

      this.setValue()
    }
  },
  mounted() {
    const value = this.value ? this.value : ''
    this.selectedTags = this.tags.filter((tag) => {
      return value.includes(tag.id)
    })

    this.availableTags = this.tags.filter((tag) => {
      return (tag.template.includes('ptag') || 
      tag.template.includes('imageTag') || 
      tag.template.includes('buttonTag') || 
      tag.template.includes('filter') || 
      tag.template.includes('cover') || 
      tag.template.includes('textbox')) &&
      !value.includes(tag.id)
    })
  }
};
</script>
